// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2wIGm","selects":"Documents_selects__2Cmgz"};